import { FieldProps } from 'formik';
import React from 'react';
import { MunicipalityInvoiceHelper } from '../../../@types/model/transformer/invoice/municipalityInvoice';
import WhiteTextField from '../../customComponents/textField/WhiteTextField';
import { connect } from 'react-redux';
import { IRootState } from '../../../@types/redux';
import { IValueAddedTax } from '../../../@types/model/masterData/valueAddedTax/valueAddedTax';
import MasterDataValueAddedTaxFunctions from '../../../store/masterData/valueAddedTax/functions';

interface IMunicipilityInvoiceCreditFormFieldProps extends FieldProps<number | null> {
    valueAddedTaxes : Array<IValueAddedTax>;
}

interface IMunicipilityInvoiceCreditFormFieldState {}

class MunicipilityInvoiceCreditFormFieldComponent extends React.PureComponent<IMunicipilityInvoiceCreditFormFieldProps, IMunicipilityInvoiceCreditFormFieldState> {
    constructor(props : IMunicipilityInvoiceCreditFormFieldProps) {
        super(props);
        this.state = {};
    }

    private readonly onChange = (event : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        this.props.field.onChange(event);

        setTimeout(() => {
            MunicipalityInvoiceHelper.calculateTotals(this.props.form, this.props.valueAddedTaxes);
        });
    };

    public readonly componentDidMount = () => {
        this.loadVatMasterData();
    };
    
    private readonly loadVatMasterData = () => {
        MasterDataValueAddedTaxFunctions.load();
    };

    public readonly render = () => {
        const {
            field,
        } = this.props;
        return (
            <WhiteTextField
                {...field}
                value={field.value ?? ''}
                variant='standard'
                label='Credit (Excl VAT)'
                fullWidth
                type='number'
                onChange={this.onChange}
            />
        );
    };
}

const mapStateToProps = (state : IRootState) => {
    return {
        valueAddedTaxes: state.masterData.valueAddedTax.valueAddedTaxes,
    };
};
    
const MunicipilityInvoiceCreditFormField = connect(
    mapStateToProps,
)(MunicipilityInvoiceCreditFormFieldComponent);

export default MunicipilityInvoiceCreditFormField;
